import { render, staticRenderFns } from "./UpdateProgressBar.vue?vue&type=template&id=726dc507&scoped=true"
import script from "./UpdateProgressBar.vue?vue&type=script&lang=js"
export * from "./UpdateProgressBar.vue?vue&type=script&lang=js"
import style0 from "./UpdateProgressBar.vue?vue&type=style&index=0&id=726dc507&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726dc507",
  null
  
)

export default component.exports